import type {
  AirlinePNR,
  Car,
  Flight,
  Hotel,
  PaymentData,
  PaymentStatus,
} from '@/modules/Book/types/model/pay'

export enum ReviewTripsType {
  All = 'All',
  Active = 'Active',
  Past = 'Past',
}

export enum ReviewTripOrderBy {
  BookingDate = 'BookingDate',
  TravelDate = 'TravelDate',
}

export enum TripItemStatus {
  BookPending = 'BookPending',
  BookSucceeded = 'BookSucceeded',
  BookFailed = 'BookFailed',
  PaymentPending = 'PaymentPending',
  PaymentSucceeded = 'PaymentSucceeded',
  PaymentFailed = 'PaymentFailed',
  CancelSucceeded = 'CancelSucceeded',
  ProviderPending = 'ProviderPending',
  Issued = 'Issued',
  IssueFailed = 'IssueFailed',
  RefundPending = 'RefundPending',
  Refunded = 'Refunded',
  RefundFailed = 'RefundFailed',
}

export enum TravelMode {
  Flight = 1,
  Hotel,
  Car,
  FlightAndHotel,
  FlightAndCar,
  HotelAndCar,
  FlightAndHotelAndCar,
}

export enum BookingSource {
  Swap = 'Swap',
  User = 'User',
}

export interface TripDetail {
  jmBookConfirmation: string
  customerCode: string
  status: PaymentStatus
  referenceId: string
  flightBookingInfo: Array<Flight>
  hotelBookingInfo: Array<Hotel>
  carBookingInfo: Array<Car>
  paymentData: PaymentData
  bookingSource: BookingSource | null
}

export interface Passenger {
  tripName: string
  paxOrder: number
  paxFirstName: string
  paxLastName: string
  paxType: number
}

export interface Supplier {
  isSelfTransfer: boolean
  tripName: string
  supplierOrder: number
  supplierCode: string
  supplierType: string
  supplierFlightNum: number
  supplierAddress: string
  supplierPropertyName: string
  supplierOrigin: string
  supplierDestination: string
  supplierStartDate: string
  supplierDepartureTime: string
  supplierEndDate: string
  supplierArrivalTime: string
  supplierCabin: string
  supplierClass: string
  contentSupplier: string
  supplierConfirmation: string
  itineraryId: number
  supplierSegmentDuration: string
  optionId: string
  ticketTimeLimit: string
  rebookIndicator: string
  userTicketId: number
}

export interface FlightTripInfo {
  origin: string
  destination: string
  passengerCount: number
  departureDate: string
  status: TripItemStatus
  pnrCode?: string
  airlinePnrCode: string | null
  airlinePNR: Array<AirlinePNR>
}

export interface HotelTripInfos {
  name: string
  destination: string
  roomCount: number
  passengerCount: number
  checkinDate: string
  imageUrl: string
  status: TripItemStatus
}

export interface CarTripInfos {
  destination: string
  name: string
  pickupDate: string
  imageUrl: string
  status: TripItemStatus
}

export interface TripItem {
  bookingSource: BookingSource | null
  jmBookConfirmation: string
  customerCode: string
  status: string
  bookDateTime: string
  flightTripInfos: Array<FlightTripInfo>
  hotelTripInfos: Array<HotelTripInfos>
  carTripInfos: Array<CarTripInfos>
  totalPaidAmount: number
  currency: string
}
